module.exports = __webpack_public_path__ + "img/value_mock.d55aa306.png";